import axios from 'axios';

// No baseURL on purpose
const axiosInstance = axios.create();

// ✅ Global request interceptor (headers only)
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        const code = localStorage.getItem('auth_code'); // optional extra header
        if (token) {
            config.headers.set('Authorization', `Bearer ${token}`);
        }
        if (code) {
            config.headers.set('code', code);
        }

        return config;
    },
    (error) => Promise.reject(error)
);
export default axiosInstance;
